/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "contract IWETH",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "attestToken",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransferAndUnwrapETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "createWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        name: "encodeAssetMeta",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "outstandingBridged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseAssetMeta",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "updateWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "wrapAndTransferETH",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var BridgeImplementation__factory = /** @class */ (function (_super) {
    __extends(BridgeImplementation__factory, _super);
    function BridgeImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BridgeImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BridgeImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BridgeImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BridgeImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BridgeImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    BridgeImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    BridgeImplementation__factory.bytecode = _bytecode;
    BridgeImplementation__factory.abi = _abi;
    return BridgeImplementation__factory;
}(ContractFactory));
export { BridgeImplementation__factory };
